export enum ETypeMateriel {
    SASPerso = 1,
    UMD = 2
}